import React, { useState } from 'react';

import { inputs, actions } from '@ecosystem/newron-design-system';
import { Entity } from '@ecosystem/newron-core/types';
import { ListItem } from '@ecosystem/newron-design-system/build/components/listBox/types';
const { ListBox } = inputs;
const { Button } = actions;
type TopBrandsRadioSelectorProps = {
  selectedTopValue: Entity;
  selectedQuantityType: Entity;
  topValueOptions: Entity[];
  quantityTypeOptions: Entity[];
  competitorTypeOption: string;
  setTopValue: React.Dispatch<React.SetStateAction<Entity>>;
  setQuantityType: React.Dispatch<React.SetStateAction<Entity>>;
  disabled: boolean;
};

function TopBrandsRadioSelector({
  selectedTopValue,
  selectedQuantityType,
  topValueOptions,
  quantityTypeOptions,
  setTopValue,
  setQuantityType,
  competitorTypeOption,
  disabled,
}: Readonly<TopBrandsRadioSelectorProps>) {
  const [isTopOptionsOpen, setIsTopOptionsOpen] = useState<boolean>(false);
  const [isQuantityOptionsOpen, setIsQuantityOptionsOpen] = useState<boolean>(false);
  const handleTopValueChange = (newTopValue: ListItem) => {
    //null check required for selecting same option again
    if (!newTopValue) return;
    setTopValue({ label: newTopValue.label, value: newTopValue.value as string });
  };

  const handleQuantityTypeChange = (newQuantityType: ListItem) => {
    //null check required for selecting same option again
    if (!newQuantityType) return;
    setQuantityType({ label: newQuantityType.label, value: newQuantityType.value as string });
  };

  return (
    <div className="inline-flex">
      <div className="pt-2">Top</div>
      <div>
        <ListBox
          list={topValueOptions}
          isOpen={isTopOptionsOpen}
          setIsOpen={setIsTopOptionsOpen}
          sectionDivider="thin"
          width={300}
          onChange={handleTopValueChange}
          value={{
            label: selectedTopValue.label,
            value: selectedTopValue.value,
          }}
        >
          <ListBox.ButtonSlot>
            <Button onClick={() => setIsTopOptionsOpen(!isTopOptionsOpen)} mode="simple" disabled={disabled}>
              {selectedTopValue.label}
              <Button.Icon>
                <Button.Icon.icons.ChevronDown />
              </Button.Icon>
            </Button>
          </ListBox.ButtonSlot>
        </ListBox>
        {competitorTypeOption} by
        <ListBox
          list={quantityTypeOptions}
          isOpen={isQuantityOptionsOpen}
          setIsOpen={setIsQuantityOptionsOpen}
          sectionDivider="thin"
          width={300}
          onChange={handleQuantityTypeChange}
          value={{
            label: selectedQuantityType.label,
            value: selectedQuantityType.value,
          }}
        >
          <ListBox.ButtonSlot>
            <Button onClick={() => setIsQuantityOptionsOpen(!isQuantityOptionsOpen)} mode="simple" disabled={disabled}>
              {selectedQuantityType.label}
              <Button.Icon>
                <Button.Icon.icons.ChevronDown />
              </Button.Icon>
            </Button>
          </ListBox.ButtonSlot>
        </ListBox>
      </div>
    </div>
  );
}

export { TopBrandsRadioSelector };
